import { render, staticRenderFns } from "./TaskEditor.vue?vue&type=template&id=37c16c82&scoped=true&"
import script from "./TaskEditor.vue?vue&type=script&lang=js&"
export * from "./TaskEditor.vue?vue&type=script&lang=js&"
import style0 from "./TaskEditor.vue?vue&type=style&index=0&id=37c16c82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37c16c82",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/timefly-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37c16c82')) {
      api.createRecord('37c16c82', component.options)
    } else {
      api.reload('37c16c82', component.options)
    }
    module.hot.accept("./TaskEditor.vue?vue&type=template&id=37c16c82&scoped=true&", function () {
      api.rerender('37c16c82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/TaskEditor.vue"
export default component.exports